// extracted by mini-css-extract-plugin
export default {"container":"VN-z","disabled":"WN-z","bgBlack":"XN-z","content":"YN-z","countdown":"ZN-z","topCaption":"_N-z","topHeading":"aO-z","heading":"bO-z","copy":"cO-z"};